import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useInternalLdapUser } from "../../../../reactQuery/users";
import useMutate from "../../../../hooks/useMutate";
import { internalInviteSchema, schema } from "../../../../schemas/inviteUser";
import {
  inviteExternalUser,
  inviteInternalUser,
} from "../../../../services/apiUser";

export function useInviteUserForm({ onClose }) {
  const [apiError, setApiError] = useState("");
  const [tab, setTab] = useState("externalUser");
  const { data } = useInternalLdapUser();

  const formMethods = useForm({
    resolver: yupResolver(tab === "internalUser" ? internalInviteSchema : schema),
    defaultValues: {
      tab: "externalUser",
    },
  });

  const { handleSubmit, watch } = formMethods;
  const tabValue = watch("tab");

  useEffect(() => {
    setTab(tabValue);
  }, [tabValue]);

  const { mutate, isPending: loading } = useMutate(
    tab === "internalUser" ? inviteInternalUser : inviteExternalUser,
    ["LDAPinternalList", "users"],
    () => {},
    () => {
      onClose();
    }
  );

  const submit = useCallback(
    (formData) => {
      setApiError("");

      if (tab === "internalUser") {
        const selected = data?.data?.data?.responseData?.find(
          (_item, index) => index === Number(formData.user)
        );

        if (!selected) {
          return;
        }

        mutate({
          first_name: selected.first_name,
          last_name: selected.last_name,
          email: selected.mail || "null",
        });
        return;
      }

      const newFormData = { ...formData };
      delete newFormData.tab;
      mutate(newFormData);
    },
    [data, mutate, tab]
  );

  const userOptions = useMemo(
    () =>
      data?.data?.data?.responseData.map((item, index) => ({
        label: `${item.first_name} ${item.last_name}`,
        value: String(index),
      })) || [],
    [data]
  );

  return {
    apiError,
    tab,
    loading,
    userOptions,
    formMethods,
    handleSubmit,
    submit,
  };
}
